import './PublicOfferPage.css';

function PublicOfferPage() {
  return (
    <div className="public-offer-page">
      <div className="offer-container">
        <h1 className="offer-title">ПУБЛИЧНАЯ ОФЕРТА</h1>
        
        <p className="offer-subtitle">
          (Договор оказания услуг с использованием Telegram-бота QuickSignAi; Версия 1.0 от 02 января 2026 года)
        </p>

        <section className="offer-section">
          <h2>1. Общие положения</h2>
          
          <p><strong>1.1.</strong> Настоящий документ является официальным предложением (публичной офертой) Самозанятой Шариповой Малики Азимджоновны (далее — Исполнитель) заключить договор оказания услуг с использованием Telegram-бота QuickSignAi (далее — Бот) на условиях, изложенных ниже.</p>
          
          <p><strong>1.2.</strong> В соответствии со статьёй 437 Гражданского кодекса Российской Федерации настоящий документ признаётся публичной офертой.</p>
          
          <p><strong>1.3.</strong> Акцептом настоящей Оферты признаётся факт начала использования Бота, включая отправку любого сообщения или нажатие функциональных кнопок в интерфейсе Бота.</p>
          
          <p><strong>1.4.</strong> Настоящая Оферта является публичным договором и регулируется законодательством Российской Федерации.</p>
          
          <p><strong>1.5.</strong> Исполнитель вправе в любое время изменять условия Оферты в одностороннем порядке, размещая новую редакцию в Боте и/или на официальных ресурсах. Изменения вступают в силу с момента публикации, если иное не указано в самой Оферте.</p>
        </section>

        <section className="offer-section">
          <h2>2. Термины и определения</h2>
          
          <p>Для целей настоящей Оферты используются следующие термины:</p>
          
          <p><strong>2.1. Бот</strong> — автоматизированный программный сервис в мессенджере Telegram, предоставляющий функционал по подписанию документов электронной печатью и подписью, включая обработку изображений с использованием технологий искусственного интеллекта.</p>
          
          <p><strong>2.2. Исполнитель</strong> — Самозанятая Шарипова Малика Азимджоновна, оказывающая Услуги через Бот.</p>
          
          <p><strong>2.3. Пользователь</strong> — физическое или юридическое лицо, обладающее необходимой дееспособностью для заключения договора и принявшее условия Оферты.</p>
          
          <p><strong>2.4. Услуги</strong> — предоставление доступа к функционалу Бота, включая подписание документов, обработку изображений печатей и подписей, хранение и управление документами, в соответствии с выбранным тарифным планом.</p>
          
          <p><strong>2.5. Бесплатный тариф</strong> — тарифный план, предоставляющий доступ к подписанию ограниченного количества документов (3 документа) с базовым функционалом.</p>
          
          <p><strong>2.6. Платный тариф (Подписка)</strong> — один из тарифных планов (Базовый 100, Базовый 200, Базовый 500), предоставляющий расширенный доступ к функционалу Бота в соответствии с выбранным пакетом документов.</p>
          
          <p><strong>2.7. Акцепт</strong> — полное и безоговорочное принятие условий настоящей Оферты Пользователем путём начала использования Бота.</p>
          
          <p><strong>2.8. Персональные данные</strong> — любая информация, относящаяся к идентифицированному или идентифицируемому физическому лицу, включая переданные Пользователем документы, изображения печатей и подписей.</p>
          
          <p><strong>2.9. Обработка данных</strong> — любое действие с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление и уничтожение.</p>
        </section>

        <section className="offer-section">
          <h2>3. Предмет договора</h2>
          
          <p><strong>3.1.</strong> Исполнитель обязуется предоставлять Пользователю Услуги посредством Бота в соответствии с выбранным тарифным планом, а Пользователь обязуется использовать Бот на условиях настоящей Оферты и производить оплату Услуг в установленном порядке.</p>
          
          <p><strong>3.2.</strong> Функционал Бота включает, но не ограничивается:</p>
          <ul>
            <li>загрузка и хранение печатей и подписей с автоматическим удалением фона с использованием технологий искусственного интеллекта;</li>
            <li>подписание документов в форматах PDF, DOCX, PNG, JPG электронными печатями и подписями;</li>
            <li>размещение печатей и подписей на документах с возможностью настройки размера и положения;</li>
            <li>хранение истории подписанных документов;</li>
            <li>управление коллекцией печатей и подписей.</li>
          </ul>
          
          <p><strong>3.3.</strong> Бот является вспомогательным техническим сервисом для работы с документами. Исполнитель не осуществляет юридическое консультирование и не несёт ответственности за юридические последствия использования подписанных документов.</p>
          
          <p><strong>3.4.</strong> Электронные печати и подписи, размещаемые с помощью Бота, не являются усиленными квалифицированными электронными подписями в смысле Федерального закона от 06.04.2011 № 63-ФЗ «Об электронной подписи» и предназначены для внутреннего документооборота.</p>
        </section>

        <section className="offer-section">
          <h2>4. Порядок оказания услуг</h2>
          
          <p><strong>4.1.</strong> Услуги оказываются круглосуточно при условии наличия технической возможности и работоспособности платформы Telegram.</p>
          
          <p><strong>4.2.</strong> Доступ к платному тарифу предоставляется после поступления оплаты на счёт Исполнителя и подтверждения платёжной системой.</p>
          
          <p><strong>4.3.</strong> В случае технических сбоев Исполнитель принимает меры для их устранения в разумные сроки, но не гарантирует абсолютную бесперебойную работу Бота.</p>
          
          <p><strong>4.4.</strong> Исполнитель вправе временно приостанавливать предоставление Услуг для проведения профилактических и технических работ, по возможности уведомив Пользователей заблаговременно.</p>
          
          <p><strong>4.5.</strong> Качество обработки изображений печатей и подписей зависит от качества исходных изображений, предоставленных Пользователем.</p>
        </section>

        <section className="offer-section">
          <h2>5. Стоимость услуг, порядок оплаты и автопродление</h2>
          
          <p><strong>5.1.</strong> Стоимость Подписки составляет:</p>
          <ul>
            <li><strong>Годовой 5000:</strong> 5 000 (пять тысяч) рублей за пакет из 5 000 документов сроком на 365 календарных дней;</li>
            <li><strong>Базовый 50:</strong> 300 (триста) рублей за пакет из 50 документов сроком на 30 календарных дней;</li>
            <li><strong>Базовый 100:</strong> 500 (пятьсот) рублей за пакет из 100 документов сроком на 30 календарных дней;</li>
            <li><strong>Базовый 200:</strong> 750 (семьсот пятьдесят) рублей за пакет из 200 документов сроком на 30 календарных дней;</li>
            <li><strong>Базовый 500:</strong> 1 000 (одна тысяча) рублей за пакет из 500 документов сроком на 30 календарных дней.</li>
          </ul>
          
          <p><strong>5.2.</strong> Оплата осуществляется безналичным способом через доступные платёжные системы Российской Федерации.</p>
          
          <p><strong>5.3.</strong> Подписка действует согласно выбранному тарифному плану (30 или 365 календарных дней) с момента активации. Автоматическое продление не осуществляется — по истечении срока Пользователь должен самостоятельно оформить новую Подписку.</p>
          
          <p><strong>5.4.</strong> Оплаченные суммы не возвращаются, включая случаи неполного использования оплаченного пакета документов или досрочного прекращения использования Бота по инициативе Пользователя.</p>
          
          <p><strong>5.5.</strong> Исполнитель вправе изменить стоимость Подписки, уведомив Пользователей не менее чем за 7 календарных дней до вступления изменений в силу путём размещения информации в Боте.</p>
          
          <p><strong>5.6.</strong> Все тарифы включают безлимитное количество печатей и подписей, полную историю документов и доступ ко всем функциям Бота.</p>
        </section>

        <section className="offer-section">
          <h2>6. Права и обязанности сторон</h2>
          
          <p><strong>6.1. Исполнитель обязуется:</strong></p>
          <ul>
            <li>предоставлять доступ к Боту в соответствии с выбранным тарифным планом;</li>
            <li>обеспечивать защиту персональных данных Пользователей в соответствии с законодательством РФ;</li>
            <li>уведомлять Пользователей об изменениях условий Оферты;</li>
            <li>обеспечивать техническую поддержку Пользователей.</li>
          </ul>
          
          <p><strong>6.2. Исполнитель вправе:</strong></p>
          <ul>
            <li>приостанавливать или прекращать доступ Пользователя при нарушении условий настоящей Оферты;</li>
            <li>вносить изменения в функционал Бота без предварительного уведомления;</li>
            <li>устанавливать технические ограничения на использование Бота;</li>
            <li>запрашивать дополнительную информацию для идентификации Пользователя.</li>
          </ul>
          
          <p><strong>6.3. Пользователь обязуется:</strong></p>
          <ul>
            <li>предоставлять достоверную информацию при использовании Бота;</li>
            <li>не передавать доступ к своему аккаунту третьим лицам;</li>
            <li>не использовать Бот в незаконных целях или для нарушения прав третьих лиц;</li>
            <li>не пытаться получить несанкционированный доступ к системам Бота;</li>
            <li>своевременно производить оплату выбранного тарифного плана.</li>
          </ul>
          
          <p><strong>6.4. Пользователь вправе:</strong></p>
          <ul>
            <li>использовать функционал Бота в соответствии с выбранным тарифом;</li>
            <li>обращаться в службу поддержки по вопросам использования Бота;</li>
            <li>в любое время прекратить использование Бота.</li>
          </ul>
        </section>

        <section className="offer-section">
          <h2>7. Обработка и хранение данных</h2>
          
          <p><strong>7.1.</strong> Пользователь соглашается на обработку персональных данных в объёме, необходимом для оказания Услуг, в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».</p>
          
          <p><strong>7.2.</strong> Исполнитель обрабатывает следующие данные Пользователя: идентификатор Telegram, имя пользователя, загруженные документы, изображения печатей и подписей, данные о транзакциях.</p>
          
          <p><strong>7.3.</strong> Исполнитель принимает организационные и технические меры по защите данных от неправомерного доступа, уничтожения, изменения, блокирования, копирования, распространения, но не несёт ответственности за утечку данных по причинам, не зависящим от него.</p>
          
          <p><strong>7.4.</strong> Данные Пользователя хранятся на защищённых серверах в течение срока использования Услуг и 90 дней после прекращения использования, если иное не предусмотрено законодательством РФ.</p>
          
          <p><strong>7.5.</strong> Пользователь вправе запросить удаление своих персональных данных, направив письменный запрос Исполнителю на адрес электронной почты sharipovamalika.456@gmail.com. Исполнитель обязуется удалить данные в течение 30 дней с момента получения запроса.</p>
          
          <p><strong>7.6.</strong> Исполнитель не передаёт персональные данные Пользователей третьим лицам, за исключением случаев, предусмотренных законодательством РФ.</p>
        </section>

        <section className="offer-section">
          <h2>8. Интеллектуальная собственность</h2>
          
          <p><strong>8.1.</strong> Все права на программный код, алгоритмы, дизайн, графические элементы, тексты и иные материалы, используемые в Боте, принадлежат Исполнителю или используются на основании соответствующих лицензий.</p>
          
          <p><strong>8.2.</strong> Пользователю предоставляется неисключительная, непередаваемая лицензия на использование Бота в личных или коммерческих целях в рамках его функционала.</p>
          
          <p><strong>8.3.</strong> Запрещается копировать, модифицировать, декомпилировать, распространять или использовать элементы Бота вне рамок предоставленного функционала.</p>
          
          <p><strong>8.4.</strong> Права на документы, печати и подписи, загруженные Пользователем, остаются за Пользователем. Исполнитель не претендует на права интеллектуальной собственности в отношении контента Пользователя.</p>
        </section>

        <section className="offer-section">
          <h2>9. Ответственность сторон</h2>
          
          <p><strong>9.1.</strong> Исполнитель не несёт ответственности за:</p>
          <ul>
            <li>убытки, возникшие в результате использования или невозможности использования Бота;</li>
            <li>юридические последствия использования подписанных через Бот документов;</li>
            <li>сбои в работе платформы Telegram и интегрированных платёжных сервисов;</li>
            <li>ошибки обработки изображений, вызванные низким качеством исходных файлов;</li>
            <li>потерю данных по причинам, не зависящим от Исполнителя;</li>
            <li>действия третьих лиц, получивших несанкционированный доступ к аккаунту Пользователя.</li>
          </ul>
          
          <p><strong>9.2.</strong> Максимальная ответственность Исполнителя ограничивается суммой, уплаченной Пользователем за текущий период Подписки.</p>
          
          <p><strong>9.3.</strong> Пользователь несёт полную ответственность за:</p>
          <ul>
            <li>правомерность своих действий при использовании Бота;</li>
            <li>содержание загружаемых документов, печатей и подписей;</li>
            <li>соблюдение законодательства РФ при использовании подписанных документов;</li>
            <li>сохранность данных своего аккаунта Telegram.</li>
          </ul>
          
          <p><strong>9.4.</strong> В случае предъявления третьими лицами претензий, связанных с использованием Пользователем Бота с нарушением законодательства или настоящей Оферты, Пользователь обязуется самостоятельно урегулировать такие претензии за свой счёт.</p>
        </section>

        <section className="offer-section">
          <h2>10. Форс-мажор</h2>
          
          <p><strong>10.1.</strong> Стороны освобождаются от ответственности за частичное или полное неисполнение обязательств по настоящей Оферте, если оно явилось следствием обстоятельств непреодолимой силы (форс-мажор), возникших после заключения договора.</p>
          
          <p><strong>10.2.</strong> К обстоятельствам непреодолимой силы относятся: стихийные бедствия, военные действия, террористические акты, забастовки, действия органов государственной власти, масштабные сбои в работе сетей связи и электроснабжения, кибератаки и другие обстоятельства, которые Стороны не могли предвидеть или предотвратить.</p>
          
          <p><strong>10.3.</strong> Сторона, для которой наступили обстоятельства непреодолимой силы, обязана уведомить другую Сторону в течение 5 календарных дней с момента наступления таких обстоятельств.</p>
          
          <p><strong>10.4.</strong> При продолжительности действия обстоятельств непреодолимой силы свыше 30 календарных дней любая из Сторон вправе расторгнуть договор в одностороннем порядке.</p>
        </section>

        <section className="offer-section">
          <h2>11. Порядок урегулирования споров</h2>
          
          <p><strong>11.1.</strong> Все споры и разногласия, возникающие из настоящей Оферты или в связи с ней, подлежат разрешению путём переговоров между Сторонами.</p>
          
          <p><strong>11.2.</strong> В случае невозможности урегулирования спора путём переговоров, Пользователь направляет Исполнителю письменную претензию на адрес электронной почты sharipovamalika.456@gmail.com.</p>
          
          <p><strong>11.3.</strong> Исполнитель обязуется рассмотреть претензию и направить мотивированный ответ в течение 10 рабочих дней с момента её получения.</p>
          
          <p><strong>11.4.</strong> При недостижении согласия в досудебном порядке спор передаётся на рассмотрение в суд по месту нахождения Исполнителя в соответствии с законодательством Российской Федерации.</p>
        </section>

        <section className="offer-section">
          <h2>12. Заключительные положения</h2>
          
          <p><strong>12.1.</strong> Настоящая Оферта вступает в силу с момента её размещения в Боте и действует до момента её отзыва Исполнителем.</p>
          
          <p><strong>12.2.</strong> Договор, заключённый путём акцепта настоящей Оферты, действует с момента акцепта до полного исполнения обязательств Сторонами или до его расторжения в установленном порядке.</p>
          
          <p><strong>12.3.</strong> Неиспользование Пользователем оплаченных Услуг не является основанием для возврата оплаты или продления срока действия Подписки.</p>
          
          <p><strong>12.4.</strong> Недействительность отдельных положений настоящей Оферты не влечёт недействительности Оферты в целом.</p>
          
          <p><strong>12.5.</strong> Актуальная версия Оферты всегда доступна в Боте через меню приложения.</p>
          
          <p><strong>12.6.</strong> Все уведомления, связанные с исполнением настоящей Оферты, направляются Исполнителем через Бот или на адрес электронной почты Пользователя (при наличии).</p>
        </section>

        <section className="offer-contacts">
          <h2>Реквизиты Исполнителя</h2>
          <p><strong>Самозанятая Шарипова Малика Азимджоновна</strong></p>
          <p>ИНН: 501818205010</p>
          <p>E-mail: <a href="mailto:sharipovamalika.456@gmail.com">sharipovamalika.456@gmail.com</a></p>
          <p className="offer-date">Дата размещения: 02 января 2026 года</p>
        </section>
      </div>
    </div>
  );
}

export default PublicOfferPage;

